<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <slotbar fluid align='center' :slots='2' :slotWidth='300'>
          <template v-slot:slot1>
            <h1>Contratos</h1>
          </template>
          <template v-slot:slot2>
            <v-btn color="primary" style='margin: 2px' @click="$router.push({name: 'Contactos'})">
              Contactos <i class="mdi mdi-account-multiple"></i>
            </v-btn>
            <v-btn color="primary" style='margin: 2px' type="icon" :disabled='emptySelected' @click="goFirmasBtn()">
              {{ goFirmasText }}<v-icon>mdi-check</v-icon>
            </v-btn>
          </template>
        </slotbar>
      </v-card-title>
      <v-card-text>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="contratos"
          single-select
          show-select
          @click:row="rowSelected"
          :options.sync='options'
          :server-items-length='total'
          :footer-props='{
            itemsPerPageOptions: [10, 20, 50, 100]
          }'
          no-data-text="No hay documentos disponibles">
          <template v-slot:top>
            <slotbar fluid :slots='3' :slotWidth='400'>
              <template v-slot:slot1>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" color="primary" style='margin: 2px' type="icon" @click="addContratoDialog = true"><v-icon>mdi-file-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>Añadir Contrato</span>
                </v-tooltip>
                
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" color="primary" style='margin: 2px' type="icon" @click="addPDFDialog = true"><v-icon>mdi-file-pdf</v-icon>
                    </v-btn>
                  </template>
                  <span>Subir PDF</span>
                </v-tooltip>
                
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" color="primary" style='margin: 2px' type="icon" :disabled="emptySelected || awaitingResponse || docViewDialog" @click="openDocView($event)"><v-icon>mdi-text-box-search</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver Documento</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" color="primary" style='margin: 2px' type="icon" :disabled="emptySelected || awaitingResponse" @click="descargarArchivo()"><v-icon>mdi-download</v-icon>
                    </v-btn>
                  </template>
                  <span>Descargar</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" color="primary" style='margin: 2px' type="icon" :disabled="emptySelected || awaitingResponse || selected[0].type !== 'XMLBasic'" @click="descargarArchivo('PDF_XML_EMBEDDED')">
                      <v-icon>mdi-file-pdf</v-icon><v-icon>mdi-download</v-icon>
                    </v-btn>
                  </template>
                  <span>Descargar PDF</span>
                </v-tooltip>
              </template>

              <template v-slot:slot2>
                <v-btn style='margin: 2px' color='primary' disabled>
                  TSA<v-icon>mdi-file-certificate-outline</v-icon>
                </v-btn>
                <listaNom151 :doc='selected' @verContratoEvent='openDocView($event, true)' ref='listaNom151Component'></listaNom151>
              </template>

              <template v-slot:slot3>
                <addFirmante :doc='selected' :disabled="emptySelected || terminado" @verFirmantesEvent='openComponent("firmantesComponent")' ref='addFirmanteComponent'></addFirmante>
                <Firmantes :doc='selected' :disabled="emptySelected" @terminarEvent='terminarDialog = true' @firmanteEliminadoEvent='reloadAddFirmante' ref='firmantesComponent'></Firmantes>
              </template>
            </slotbar>
          </template>
          <template v-slot:item.title="{ item }">
            {{ limitLength(item.title, 30) }}
          </template>
          <template v-slot:item.descripcion="{ item }">
            {{ limitLength(item.descripcion) }}
          </template>
          <template v-slot:item.status="{ item }">
            {{ setStatus(item.status) }}
          </template>
          <template v-slot:item.date="{ item }">
            {{ periodo(item.date) }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="addContratoDialog" fullscreen>
      <v-card>
        <v-toolbar color="primary" dark>
          <h2>Añadir Contrato</h2>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeAddContrato()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container>
          <v-card-title></v-card-title>
          <v-card-text>
            <v-textarea
            v-model="contrato.titulo"
            solo
            label="Título"
            auto-grow
            rows="1"
            no-resize
            ></v-textarea>
            <v-textarea
            v-model="contrato.descripcion"
            solo
            label="Descripción"
            auto-grow
            rows="1"
            no-resize
            ></v-textarea>
            <v-textarea
            v-model="contrato.texto"
            solo
            name="input-7-4"
            label="Contrato"
            auto-grow
            ></v-textarea>
            <v-row>
              <v-col cols="6" sm="2">
                <v-checkbox disabled v-model="tsa" label="Incluir TSA"></v-checkbox>
              </v-col>
              <v-col cols="6" sm="2">
                <v-checkbox v-model="nom" label="Incluir NOM151"></v-checkbox>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-toolbar flat>
              <v-btn color="primary" style="margin-right: 5px" :disabled="awaitingResponse" @click="addContrato()">Agregar</v-btn>
              <v-btn color="primary" @click="closeAddContrato()">Cancelar</v-btn>
            </v-toolbar>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addPDFDialog" width="600">
      <v-card>
        <v-toolbar color="primary" dark>
          <h2>Subir PDF</h2>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeAddContrato('PDF')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-title></v-card-title>
        <v-card-text>
          <form>
            <v-text-field
              v-model="contrato.titulo"
              label="Titulo"
              required
              prepend-icon="mdi-card-text-outline"
            ></v-text-field>
            <v-text-field
              v-model="contrato.descripcion"
              label="Descripción"
              required
              prepend-icon="mdi-file-document-edit-outline"
            ></v-text-field>
            <v-file-input required v-model="contrato.archivoPDF" accept=".pdf" label="Archivo PDF"></v-file-input>
            <v-row>
              <v-col cols="6" sm="4">
                <v-checkbox v-model="tsa" label="Incluir TSA"></v-checkbox>
              </v-col>
              <v-col cols="6" sm="4">
                <v-checkbox v-model="nom" label="Incluir NOM151"></v-checkbox>
              </v-col>
            </v-row>
          </form>
        </v-card-text>
        <v-card-actions>
          <v-toolbar flat>
            <v-btn color="primary" style="margin-right: 5px" :disabled="awaitingResponse" @click="addContrato('PDF')">Subir</v-btn>
            <v-btn color="primary" @click="closeAddContrato('PDF')">Cancelar</v-btn>
          </v-toolbar>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="docViewDialog" fullscreen>
      <v-card>
        <v-toolbar color="primary" dark>
          <h2 style="text-align: center; width: 100%">{{ limitLength(title, 50) }}</h2>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeDocView">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <VerContrato :loaded="docViewDialog" :documentoInit="documento" :showTitleInit="false" />
        </v-card-text>
        <v-card-actions style='margin-left: 10%; padding-bottom: 5%'>
          <v-toolbar flat class="docDiv">
            <v-btn color="primary" @click="closeDocView">Cerrar</v-btn>
          </v-toolbar>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-dialog v-model="terminarDialog" max-width="500">
      <v-card>
        <v-card-title class="headline">Terminar Documento</v-card-title>

        <v-card-text>
          ¿Estás seguro?
        </v-card-text>
        <v-card-text>
          Una vez terminado el documento ya no podrás añadir nuevos firmantes.
        </v-card-text>
        <v-card-text>
          Una vez finalizado se enviará un correo de aviso a todos los firmantes para invitarlos a la firma del documento.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" text @click="terminarDialog = false">Cancelar</v-btn>

          <v-btn color="primary" text :disabled="awaitingResponse" @click="limitFirmantes(false)">Terminar</v-btn>

          <v-btn color="primary" text :disabled="awaitingResponse" @click="limitFirmantes(true)">Terminar y proceder a firmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import addFirmante from '@/components/firma/addFirmante.vue'
  import Firmantes from '@/components/firma/firmantes.vue'
  import VerContrato from '@/components/contrato/verContrato.vue'
  import listaNom151 from '@/components/nom151/listaConstancias.vue'
  import slotbar from '@/components/custom/slotbar.vue'
  import { mapActions } from 'vuex';
  import { consoleErrorMessage, toasterErrorMessage } from '@/utils/responseCatchMessages.js';
  import { tryClick } from '@/utils/tryClick.js';
  import { ApiInit } from '@/api.js';
  export default {
    name: 'contrato',
    components:{
      addFirmante,
      Firmantes,
      VerContrato,
      listaNom151,
      slotbar,
    },
    data: () => ({
      tsa: false,
      nom: false,
      addContratoDialog: false,
      addPDFDialog: false,
      terminado: true,
      documento: {},
      terminarDialog: false,
      docViewDialog: false,
      contratos: [],
      contrato: {
        titulo: '',
        descripcion: '',
        archivoPDF: null,
        texto: '',
      },
      clienteId: '',
      selected: [],
      headers: [
        { text: 'Título', value: 'title' },
        { text: 'Descripción', value: 'descripcion' },
        { text: 'Tipo', value: 'type' },
        { text: 'Cliente', value: 'cliente.nombre' },
        { text: 'Status', value: 'status'},
        { text: 'Fecha', value: 'date'},
      ],
      options: {
        itemsPerPage: 10,
        sortBy: ['date'],
        sortDesc: [true],
      },
      total: 0,
      awaitingResponse: false,
      firstLoad: true,
      clicked: [],
    }),
    computed: {
      emptySelected() {
        if (this.selected.length === 0) return true;
        return false;
      },
      title() {
        if (this.documento.title !== undefined) return this.documento.title;
        return "";
      },
      goFirmasText() {
        if (this.emptySelected) return 'Firmar';
        if (this.selected[0].status === 'NO_FIRMADO') return 'Terminar';
        if (this.selected[0].status === 'EN_PROCESO') return 'Firmar';
        if (this.selected[0].status === 'FIRMADO') return 'Revisar';
        return 'Firmar';
      },
    },
    methods:{
      ...mapActions(['setDocument']),
      setStatus(stat){
        if(stat == "NO_FIRMADO"){
          return "Nuevo"
        }else if(stat == "EN_PROCESO"){
          return "En proceso"
        }else if(stat == "FIRMADO"){
          return "Finalizado"
        }else{
          return "Desconocido"
        }
      },
      periodo(item) {
        const fecha = this.$moment(item).format('DD MMMM YYYY, h:mm a');
        return fecha;
      },
      limitLength(str, len = 40) {
        return (str.length > len ? str.slice(0, len) + '...' : str);
      },
      async pageEventHandler(){
        this.clienteId = this.$store.getters.getClient;
        //console.log("CLIENTE: %o", this.clienteId);
        await this.getContratos();
      },
      checkSelected() {
        if (!this.emptySelected && this.selected[0].status === "NO_FIRMADO")
          this.terminado = false;
        else
          this.terminado = true;
      },
      goFirmasBtn(){
        if (!this.terminado) {
          this.terminarDialog = true;
          return;
        }
        this.goFirmas();
      },
      goFirmas() {
        //console.log("Doc1: %o",this.selected[0].id);
        this.setDocument(this.selected[0].id);
        this.$router.push({ name: 'Firmar', params: {documento: this.selected[0]}});
      },
      async limitFirmantes(goFirmar){
        const defaultToastMessage = 'Error al terminar el contrato.';
        const defaultConsoleMessage = 'limitFirmantes error';
        try {
          this.awaitingResponse = true;
          const clientId = this.clienteId;
          const documentId = this.selected[0].id;
          const result = await this.$store.dispatch('limitDocFirmantes',{clientId, documentId});
          if (result === null) {
            console.error(defaultConsoleMessage);
            this.$toast.error(defaultToastMessage);
            this.stopWait();
            return;
          }
          if (goFirmar) {
            this.goFirmas();
            return;
          }
          this.$toast.success('Contrato terminado exitosamente. Ya no se podrán agregar nuevos firmantes.');
          await this.pageEventHandler();
          this.selectDocById(documentId);
        }catch (e) {
          consoleErrorMessage(e, defaultConsoleMessage);
          toasterErrorMessage(this.$toast.error, e, defaultToastMessage);
        }
        this.terminarDialog = false;
        this.stopWait();
      },
      selectDocById(docId) {
        this.selected = [];
        for (const doc of this.contratos) {
          if (doc.id === docId) {
            this.selected[0] = doc;
            return;
          }
        }
        console.error('selectDocById: docId %s not found', docId);
      },
      async addContrato(tipo = 'XMLBasic'){
        const isPdf = (tipo === 'PDF');
        const defaultToastMessage = (isPdf ? 'Error al subir el archivo PDF.' : 'Error al agregar el contrato.');
        const defaultConsoleMessage = 'addContrato error';
        if (!this.validacionContrato()) return;
        try {
          this.awaitingResponse = true;
          const clienteId = this.clienteId;
          const titulo = this.contrato.titulo;
          const contrato = (isPdf ? this.contrato.archivoPDF : new Blob([this.contrato.texto]));
          const descripcion = this.contrato.descripcion;
          const tsa = this.tsa;
          const nom = this.nom;
          const result = await this.$store.dispatch('addFile', {clienteId, titulo, contrato, descripcion, tipo, tsa, nom});
          if (result === null) {
            console.error(defaultConsoleMessage);
            this.$toast.error(defaultToastMessage);
            this.stopWait();
            return;
          }
          await this.pageEventHandler();
          this.closeAddContrato(tipo);
          this.selectDocById(result.id);
          this.openComponent('addFirmanteComponent');
        }catch (e) {
          consoleErrorMessage(e, defaultConsoleMessage);
          toasterErrorMessage(this.$toast.error, e, defaultToastMessage);
        }
        this.stopWait();
      },
      validacionContrato() {
        if (this.contrato.titulo.length === 0) {
          this.$toast.error('Falta el título');
          return false;
        }
        if (this.contrato.titulo.length > 255) {
          this.$toast.error(`El título debe tener menos de 256 caracteres.<br>Longitud actual: ${this.contrato.titulo.length}`);
          return false;
        }
        if (this.contrato.descripcion.length === 0) {
          this.$toast.error('Falta la descripción');
          return false;
        }
        if (this.contrato.descripcion.length > 255) {
          this.$toast.error(`La descripción debe tener menos de 256 caracteres.<br>Longitud actual: ${this.contrato.descripcion.length}`);
          return false;
        }
        if (this.contrato.texto.length === 0 && this.contrato.archivoPDF === null) {
          this.$toast.error('Falta el contenido del documento');
          return false;
        }
        return true;
      },
      closeAddContrato(tipo = 'XMLBasic') {
        const isPdf = (tipo === 'PDF');
        if (isPdf) this.addPDFDialog = false;
        else this.addContratoDialog = false;
        this.clearContrato(this.contrato);
        this.tsa = false;
        this.nom = false;
      },
      clearContrato(contrato) {
        for (const key in contrato) {
          if (key === 'archivoPDF') contrato[key] = null;
          else contrato[key] = '';
        }
      },
      async openDocView(event, docFromEvent = false) {
        const defaultToastMessage = 'Error al cargar el documento.';
        const defaultConsoleMessage = 'openDocView error';
        if (this.emptySelected && !docFromEvent) return;
        this.docViewDialog = true;
        let docTemp = {};
        if (docFromEvent) docTemp = JSON.parse(JSON.stringify(event));
        else docTemp = JSON.parse(JSON.stringify(this.selected[0]));
        try {
          this.awaitingResponse = true;
          const clienteId = docTemp.cliente.id;
          const docId = docTemp.id;
          const isPdf = (docTemp.type === 'PDF');
          const downloadType = this.getDownloadType(docTemp.type);
          const methodName = (isPdf ? 'downloadDocumento' : 'getDocumentHtml');
          const result = await this.$store.dispatch(methodName, {clienteId, docId, downloadType});
          if (result === null) {
            console.error(defaultConsoleMessage);
            this.$toast.error(defaultToastMessage);
            this.stopWait();
            return;
          }
          const propName = (isPdf ? 'pdfBlob' : 'doc');
          docTemp[propName] = (isPdf ? result.data : new Blob([result.data], {type: 'text/html'}));
          this.documento = docTemp;
        } catch (e) {
          consoleErrorMessage(e, defaultConsoleMessage);
          toasterErrorMessage(this.$toast.error, e, defaultToastMessage);
        }
        this.stopWait();
      },
      closeDocView() {
        this.docViewDialog = false;
        this.clearContrato(this.documento);
      },
      async getContratos(){
        const defaultToastMessage = 'Error al obtener la lista de documentos.';
        const defaultConsoleMessage = 'getContratos error';
        try {
          const clienteId = this.clienteId;
          const options = this.options;
          const result = await this.$store.dispatch('listDocumento',{clienteId, options});
          if (result === null) {
            console.error(defaultConsoleMessage);
            this.$toast.error(defaultToastMessage);
            return;
          }
          this.total = result.totalElements;
          this.contratos = result.content;
        }catch (e) {
          consoleErrorMessage(e, defaultConsoleMessage);
          toasterErrorMessage(this.$toast.error, e, defaultToastMessage);
        }
      },
      getDownloadType(type) {
        if (type === 'XMLBasic') return 'XML';
        return type;
      },
      async descargarArchivo(dlType = null) {
        const defaultToastMessage = 'Error al solicitar la descarga.';
        const defaultConsoleMessage = 'descargarArchivo error';
        if (this.emptySelected) return;
        this.documento = JSON.parse(JSON.stringify(this.selected[0]));
        try {
          this.awaitingResponse = true;
          const clienteId = this.documento.cliente.id;
          const docId = this.documento.id;
          const downloadType = (dlType !== null ? dlType : this.getDownloadType(this.documento.type));
          const result = await this.$store.dispatch('downloadDocumento', {clienteId, docId, downloadType});
          if (result === null) {
            console.error(defaultConsoleMessage);
            this.$toast.error(defaultToastMessage);
            this.stopWait();
            return;
          }
          const downloadUrl = URL.createObjectURL(result.data);
          const filename = this.getPropertyFromString(result.headers['content-disposition'], 'filename');
          this.downloadFromTempUrl(downloadUrl, filename);
        } catch (e) {
          consoleErrorMessage(e, defaultConsoleMessage);
          toasterErrorMessage(this.$toast.error, e, defaultToastMessage);
        }
        this.stopWait();
      },
      getPropertyFromString(str, propName) {
        var match = str.match(new RegExp('(^| )' + propName + '=([^;]+)'));
        if (match) return match[2].replace(/['"]/g, '');
        else return '';
      },
      downloadFromTempUrl(url, filename) {
        var a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      },
      getFileExtension(docType) {
        if (docType === 'XMLBasic') return 'xml';
        if (docType === 'PDF') return 'pdf';
        return 'xml';
      },
      reloadAddFirmante() {
        if (this.$refs.addFirmanteComponent.dialog) this.$refs.addFirmanteComponent.getFields();
      },
      openComponent(component, activator = 'activatorButton') {
        const tryParameters = {
          count: 0,
          max: 15,
          interval: 100,
        };
        const element = this.$refs[component].$refs[activator].$el;
        tryClick(element, tryParameters);
      },
      rowSelected(obj) {
        // console.debug('rowSelected object %o', obj);
        this.checkDoubleClick(obj);
        if (this.selected.length > 0) {
          const sel = this.selected[0];
          this.selected = [];
          if (sel.id !== obj.id) this.selected.push(obj);
        } else this.selected.push(obj);
      },
      checkDoubleClick(obj) {
        const doubleClickTimeout = 500;
        const clickInfo = {
          docId: obj.id,
          expired: false,
        };
        window.setTimeout((clickInfo) => {
          clickInfo.expired = true;
        }, doubleClickTimeout, clickInfo);
        this.clicked.push(clickInfo);
        if (this.clicked.length >= 2) {
          if (this.clicked.length > 2) this.clicked.shift();
          const prev = this.clicked[0];
          const last = this.clicked[1];
          if (prev.docId === last.docId && !prev.expired) this.openDocView(obj, true);
        }
      },
      stopWait() {
        var self = this;
        window.setTimeout((obj) => { obj.awaitingResponse = false; }, 500, self);
      },
    },
    watch: {
      selected() {
        // console.log('watch selected: %o', this.selected[0].id);
        this.checkSelected();
      },
      options() {
        console.debug('watch options', JSON.parse(JSON.stringify(this.options)));
        if (this.firstLoad) {
          this.firstLoad = false;
          ApiInit().then(r => this.pageEventHandler());
        } else this.pageEventHandler();
      },
    },
  };
</script>

<style type="">
.contrato{
  margin-right: 145px;
  margin-left: 145px;
  border-color: green;
}
</style>
